import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import EntryPublicSchema from "@common/schema/entry/public";
import * as HomeRoute from "./home";

// Read-only and single-page: the dashboard summarises what the organization
// holds, so there is nothing here to create, edit or address individually.
//
// The provider is VESTIGIAL — nothing on this screen renders a widget for a
// declared type, and Section.Provider is here only to supply `base`/`basepath`
// to the route below. datum's and bucketws' dashboards carry the same one for
// the same reason, each passing its own entity's schema.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const base = `/dashboard`;
  const basepath = `/dashboard`;

  return (
    <Section.Provider
      schema={EntryPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/`} component={HomeRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={base}>Dashboard</Link>
          </BreadcrumbItem>
          <Switch>
            <Route path={`${basepath}/`} component={HomeRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <></>;
